import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { blogService } from '../../services/blogService';
import AdminLayout from '../../components/AdminLayout';

const AdminBlogs = () => {
    const [blogs, setBlogs] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        loadBlogs();
    }, []);

    const loadBlogs = async () => {
        try {
            const data = await blogService.getAllBlogsAdmin();
            setBlogs(data);
        } catch (err) {
            console.error('Error loading blogs:', err);
        }
    };

    const handleDeleteBlog = async (id) => {
        if (window.confirm('Are you sure you want to delete this blog?')) {
            try {
                await blogService.deleteBlog(id);
                loadBlogs();
            } catch (err) {
                console.error('Error deleting blog:', err);
            }
        }
    };

    return (
        <AdminLayout>
            <div>
                {/* Header Section */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '40px'
                }}>
                    <div>
                        <h1 style={{
                            fontSize: '32px',
                            fontWeight: '300',
                            color: 'var(--text-light)',
                            marginBottom: '8px'
                        }}>
                            Blog Management
                        </h1>
                        <p style={{
                            fontSize: '14px',
                            color: 'rgba(245, 241, 237, 0.6)'
                        }}>
                            Create, edit and manage your blog posts
                        </p>
                    </div>
                    <button 
                        onClick={() => navigate('/admin/blogs/new')}
                        style={{
                            padding: '14px 28px',
                            background: 'linear-gradient(135deg, var(--accent-color) 0%, #B8935D 100%)',
                            border: 'none',
                            borderRadius: '10px',
                            color: '#000',
                            fontSize: '15px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.transform = 'translateY(-2px)';
                            e.target.style.boxShadow = '0 8px 25px rgba(201, 169, 110, 0.4)';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.transform = 'translateY(0)';
                            e.target.style.boxShadow = 'none';
                        }}
                    >
                        <span style={{ fontSize: '18px' }}>📝</span>
                        Create New Blog
                    </button>
                </div>

                {/* Blogs List */}
                <div style={{
                    background: 'linear-gradient(135deg, rgba(201, 169, 110, 0.08) 0%, rgba(201, 169, 110, 0.03) 100%)',
                    border: '1px solid rgba(201, 169, 110, 0.2)',
                    borderRadius: '16px',
                    padding: '30px',
                    overflow: 'hidden'
                }}>
                    <h2 style={{
                        fontSize: '20px',
                        fontWeight: '300',
                        color: 'var(--text-light)',
                        marginBottom: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                    }}>
                        <span style={{ fontSize: '24px' }}>📚</span>
                        All Blog Posts ({blogs.length})
                    </h2>

                    {blogs.length === 0 ? (
                        <div style={{
                            textAlign: 'center',
                            padding: '60px 20px',
                            color: 'rgba(245, 241, 237, 0.5)'
                        }}>
                            <div style={{ fontSize: '48px', marginBottom: '16px' }}>📝</div>
                            <div style={{ fontSize: '16px' }}>No blog posts yet. Create your first one!</div>
                        </div>
                    ) : (
                        <div style={{ overflowX: 'auto' }}>
                            <table style={{
                                width: '100%',
                                borderCollapse: 'separate',
                                borderSpacing: '0 12px'
                            }}>
                                <thead>
                                    <tr>
                                        <th style={{
                                            textAlign: 'left',
                                            padding: '12px 16px',
                                            fontSize: '13px',
                                            fontWeight: '600',
                                            color: 'rgba(245, 241, 237, 0.7)',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px'
                                        }}>Title</th>
                                        <th style={{
                                            textAlign: 'left',
                                            padding: '12px 16px',
                                            fontSize: '13px',
                                            fontWeight: '600',
                                            color: 'rgba(245, 241, 237, 0.7)',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px'
                                        }}>Category</th>
                                        <th style={{
                                            textAlign: 'left',
                                            padding: '12px 16px',
                                            fontSize: '13px',
                                            fontWeight: '600',
                                            color: 'rgba(245, 241, 237, 0.7)',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px'
                                        }}>Status</th>
                                        <th style={{
                                            textAlign: 'left',
                                            padding: '12px 16px',
                                            fontSize: '13px',
                                            fontWeight: '600',
                                            color: 'rgba(245, 241, 237, 0.7)',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px'
                                        }}>Created</th>
                                        <th style={{
                                            textAlign: 'right',
                                            padding: '12px 16px',
                                            fontSize: '13px',
                                            fontWeight: '600',
                                            color: 'rgba(245, 241, 237, 0.7)',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px'
                                        }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {blogs.map(blog => (
                                        <tr key={blog._id} style={{
                                            background: 'rgba(255, 255, 255, 0.03)',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.06)';
                                            e.currentTarget.style.transform = 'scale(1.01)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.03)';
                                            e.currentTarget.style.transform = 'scale(1)';
                                        }}>
                                            <td style={{
                                                padding: '16px',
                                                fontSize: '15px',
                                                color: 'var(--text-light)',
                                                fontWeight: '500',
                                                borderTopLeftRadius: '10px',
                                                borderBottomLeftRadius: '10px'
                                            }}>
                                                {blog.title}
                                            </td>
                                            <td style={{
                                                padding: '16px',
                                                fontSize: '14px',
                                                color: 'rgba(245, 241, 237, 0.7)'
                                            }}>
                                                {blog.category}
                                            </td>
                                            <td style={{
                                                padding: '16px'
                                            }}>
                                                <span style={{
                                                    padding: '6px 14px',
                                                    borderRadius: '20px',
                                                    fontSize: '12px',
                                                    fontWeight: '600',
                                                    background: blog.published ? 'rgba(40, 167, 69, 0.2)' : 'rgba(255, 193, 7, 0.2)',
                                                    color: blog.published ? '#28a745' : '#ffc107',
                                                    display: 'inline-block'
                                                }}>
                                                    {blog.published ? '✓ Published' : '📄 Draft'}
                                                </span>
                                            </td>
                                            <td style={{
                                                padding: '16px',
                                                fontSize: '14px',
                                                color: 'rgba(245, 241, 237, 0.7)'
                                            }}>
                                                {new Date(blog.createdAt).toLocaleDateString()}
                                            </td>
                                            <td style={{
                                                padding: '16px',
                                                textAlign: 'right',
                                                borderTopRightRadius: '10px',
                                                borderBottomRightRadius: '10px'
                                            }}>
                                                <button
                                                    onClick={() => navigate(`/admin/blogs/edit/${blog._id}`)}
                                                    style={{
                                                        padding: '8px 18px',
                                                        background: 'rgba(201, 169, 110, 0.2)',
                                                        border: '1px solid var(--accent-color)',
                                                        borderRadius: '8px',
                                                        color: 'var(--accent-color)',
                                                        fontSize: '13px',
                                                        fontWeight: '600',
                                                        cursor: 'pointer',
                                                        marginRight: '8px',
                                                        transition: 'all 0.3s ease'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.background = 'var(--accent-color)';
                                                        e.target.style.color = '#000';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.background = 'rgba(201, 169, 110, 0.2)';
                                                        e.target.style.color = 'var(--accent-color)';
                                                    }}
                                                >
                                                    ✏️ Edit
                                                </button>
                                                <button
                                                    onClick={() => handleDeleteBlog(blog._id)}
                                                    style={{
                                                        padding: '8px 18px',
                                                        background: 'rgba(230, 57, 70, 0.2)',
                                                        border: '1px solid #E63946',
                                                        borderRadius: '8px',
                                                        color: '#E63946',
                                                        fontSize: '13px',
                                                        fontWeight: '600',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.3s ease'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.background = '#E63946';
                                                        e.target.style.color = '#fff';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.background = 'rgba(230, 57, 70, 0.2)';
                                                        e.target.style.color = '#E63946';
                                                    }}
                                                >
                                                    🗑️ Delete
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </AdminLayout>
    );
};

export default AdminBlogs;

